import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ServicesSlider = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const services = [
    {
      number: "01",
      icon: "/img/city-transport.png",
      title: "City Transfer",
      desc: "Fast and reliable city pickup & drop services across Pune.",
    },
    {
      number: "02",
      icon: "/img/airport-transport.png",
      title: "Airport Transfer",
      desc: "Hassle‑free Pune Airport pickup & drop with professional drivers.",
    },
    {
      number: "03",
      icon: "/img/hospital-transport.png",
      title: "Hospital Transfer",
      desc: "Comfortable & safe cab service for medical visits and emergencies.",
    },
    {
      number: "04",
      icon: "/img/wedding-ceremony.png",
      title: "Wedding Ceremony",
      desc: "Premium cars for weddings, functions, and special events.",
    },
    {
      number: "05",
      icon: "/img/hotel-transport.png",
      title: "Whole City Tour",
      desc: "Explore Pune city with our full‑day sightseeing cab service.",
    },
    {
      number: "06",
      icon: "/img/luggege-transport.png",
      title: "Baggage Transport",
      desc: "Dedicated luggage & goods transport with secure handling.",
    },
  ];

  return (
    <section className="gauto-service-area section_70">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="site-heading">
              <h4>see our</h4>
              <h2>Latest Services</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <Slider {...settings}>
              {services.map((service, index) => (
                <div key={index} className="single-service">
                  <span className="service-number">{service.number}</span>

                  <div className="service-icon">
                    <img src={service.icon} alt={service.title} />
                  </div>

                  <div className="service-text">
                    <h3>{service.title}</h3>
                    <p>{service.desc}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSlider;
